import { render, staticRenderFns } from "./diffchart.vue?vue&type=template&id=6da62a33&scoped=true"
import script from "./diffchart.vue?vue&type=script&lang=js"
export * from "./diffchart.vue?vue&type=script&lang=js"
import style0 from "./diffchart.vue?vue&type=style&index=0&id=6da62a33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da62a33",
  null
  
)

export default component.exports